// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/static/" + chunkId + "." + "1b8a01fecfb1e3f74043e3364fca2112929218d241c1ba2ee975ab7627577e88" + ".css";
};